var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"deck-builder"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('DeckList')],1),_c('div',{staticClass:"col-4"},[_c('CardLibrary')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }